module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help"
  }, [_c('h2', [_vm._v("Help")]), _vm._v(" "), _c('div', {
    staticClass: "scores"
  }, [_c('strong', [_vm._v("Power ups")]), _vm._v(" "), _c('p', [_vm._v("\n      On every 7th level or getting a c-c-combo (clearing the field with one combo) will reward you with one random power up\n      "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "power-up-list"
  }, [_c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-bomb"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Bomb")]), _vm._v(" "), _c('p', [_vm._v("Kill one tile and hurt the ones around it.")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt-v"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Remove vertical")]), _vm._v(" "), _c('p', [_vm._v("Remove a vertical line")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt-h"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Remove horizontal")]), _vm._v(" "), _c('p', [_vm._v("Remove a horizontal line")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Remove up-down")]), _vm._v(" "), _c('p', [_vm._v("Remove horizontal and vertical line")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Taps +10'")]), _vm._v(" "), _c('p', [_vm._v("Get 10 extra taps")])])])])])]), _vm._v(" "), _c('strong', [_vm._v("Combos")]), _vm._v(" "), _c('p', [_vm._v("Bigger combos equals bigger score and bigger bonuses")]), _vm._v(" "), _c('strong', [_vm._v("Combo progress")]), _vm._v(" "), _c('p', [_vm._v("A full combo progress will add one point to your tap damage. Your progress is\n      "), _c('strong', [_vm._v("not")]), _vm._v(" reset after each level. ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73789f26","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help.vue
// module id = 114
// module chunks = 1